// Render order for a trial that has never been touched via App Activities Order (no
// TrialModuleOrder rows at all) — this is the order the six modules always rendered in
// before repeatable steps existed.
const FALLBACK_MODULE_ORDER = [
  "POEM",
  "Advanced Surveys",
  "Videos",
  "Photos",
  "AI Assessment",
  "Instructions",
];

// Display-only labels for module types whose backend value (TrialModule.choices) is kept
// stable for matching/persistence — only what's shown to staff changes.
const MODULE_DISPLAY_LABELS = {
  POEM: "POEMs",
  "Advanced Surveys": "ePRO",
};
export const moduleLabel = (module) => MODULE_DISPLAY_LABELS[module] || module;

// The trial's ordered, potentially-repeated step list. A trial that has never been
// configured via App Activities Order (no trial_modules at all, and never saved as
// configured) falls back to one virtual step per default module, in the same fixed order
// this screen always rendered them in. A trial that HAS been configured before -- even
// down to zero steps, deliberately -- shows exactly what it has, no fallback.
export const getVisibleSteps = (trial) =>
  trial?.trial_modules?.length
    ? [...trial.trial_modules]
        .filter((m) => m.enabled !== false)
        .sort((a, b) => a.position - b.position)
    : trial?.app_activities_configured
      ? []
      : FALLBACK_MODULE_ORDER.map((module) => ({ id: null, module, title: moduleLabel(module) }));
